import { useForm, Controller } from "react-hook-form";
import {
  Box,
  TextField,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Typography,
} from "@mui/material";
import { addBranch } from "../utils/api";
import { useState } from "react";

const ProductForm = ({
  done,
  setSnackbarMessage,
  setSnackbarSeverity,
  handleOpenSnackbar,
}) => {
  const { handleSubmit, control, watch, reset } = useForm();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const password1 = watch("pwAm", ""); // Watch the first user's password
  const password2 = watch("pwPm", ""); // Watch the second user's password

  const onSubmit = async (data) => {
    try {
      setIsButtonDisabled(true);
      const response = await addBranch(data);
      if (response.status === 201) {
        const message = (
          <>
            {response.data.message}
            <br />
            {"Branch: "}
            {response.data?.data?.name}
            <br />
            {"Users: "}
            {response.data?.data?.usernameAm} {" and "}
            {response.data?.data?.usernamePm}
          </>
        );
        setSnackbarMessage(message || "Successful");
        setSnackbarSeverity("success");
        handleOpenSnackbar();
        reset();
        done();
      } else {
        setSnackbarMessage(response.data.message || "Failed");
        setSnackbarSeverity("error");
        handleOpenSnackbar();
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage(
        error?.response?.data?.message ||
          "An error occurred. Please try again later."
      );
      setSnackbarSeverity("error");
      handleOpenSnackbar();
    }
  };

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          maxWidth: 400,
          margin: "0 auto",
        }}
      >
        <Typography variant="caption">
          Branch name and usernames of morning and night shift users will be
          generated automatically.
        </Typography>
        <Controller
          name="pwAm"
          control={control}
          defaultValue=""
          rules={{ required: "Password for morning shift is required" }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              size="small"
              label="Morning Shift Password"
              type="password"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
            />
          )}
        />
        <Controller
          name="confirmPassword1"
          control={control}
          defaultValue=""
          rules={{
            required: "Confirm password for morning shift is required",
            validate: (value) =>
              value === password1 || "Passwords for morning shift do not match",
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              size="small"
              label="Confirm Password"
              type="password"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
              sx={{ marginBottom: 2 }}
            />
          )}
        />
        <Controller
          name="pwPm"
          control={control}
          defaultValue=""
          rules={{ required: "Password for night shift is required" }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              size="small"
              label="Night Shift Password"
              type="password"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
            />
          )}
        />
        <Controller
          name="confirmPassword2"
          control={control}
          defaultValue=""
          rules={{
            required: "Confirm password for night shift is required",
            validate: (value) =>
              value === password2 || "Passwords for night shift do not match",
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              size="small"
              label="Confirm Password"
              type="password"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
              sx={{ marginBottom: 2 }}
            />
          )}
        />
        <Box textAlign="right">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isButtonDisabled}
          >
            Save
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ProductForm;
